import { toast } from "react-toastify"
import { toastOptions } from "../config/toast"
import { axios } from "../utils/axios"

export const postForm = async (
    path,
    form,
    setLoading,
) => {
    setLoading && setLoading(true)

    const response = await axios().post(path, form)
    const { data, error } = response.data

    if (data) {
        setLoading && setLoading(false)
        return data
    }

    if (error) {
        toast.error(error, toastOptions)
        setLoading && setLoading(false)
        return null
    }
}